// What is Site Code: https://support.wix.com/en/article/corvid-working-in-the-code-panel
import wixLocation from 'wix-location';
$w.onReady(function () {
	// Write your code here
	let prefix = wixLocation.prefix; // "animals"
if (prefix === "圍牆上的圖書館") {

	$w("#quickActionBar1").expand()
}
});